<template>
    <div class="files">
        <ul class="list-group">
            <li v-for="file in files" class="list-group-item row">
            {{file.name}}
            <a v-bind:href="file.url" target="_blank" class="btn btn-primary btn-xs">Download</a>
            </li>
        </ul>
    </div>

</template>


<script>

import files from '../../../services/files';

export default {
    props: ['instanceId'],
    name: 'files',
    data() {
        return {
            files: null
        }
    },
    mounted() {
        this.getFiles();
    },
    methods: {
        getFiles() {
            var self = this;
            files.get(self, self.instanceId).then(function(response) {
                self.files = response.data;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
a {
    float:right;
}
</style>


// WEBPACK FOOTER //
// Files.vue?3f8c37e1